import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Footer.css";

function Footer() {
  const location = useLocation();

  const handleLinkClick = (targetPath) => {
    if (location.pathname === targetPath) {
      // If already on the target page, scroll to the top instantly
      window.scrollTo({ top: 0, behavior: "instant" });
    }
    //closeMobileMenu(); // Close the mobile menu
    // handleClick();
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <ul className="footer-menu">
          <li className="footer-item">
            <Link
              to="/film"
              className="footer-links"
              onClick={() => handleLinkClick("/film")}
            >
              35mm
            </Link>
          </li>
          <li className="footer-item">
            <Link
              to="/aesthetics"
              className="footer-links"
              onClick={() => handleLinkClick("/aesthetics")}
            >
              Aesthetics
            </Link>
          </li>
          <li className="footer-item">
            <Link
              to="/"
              className="footer-links"
              onClick={() => handleLinkClick("/")}
            >
              Fashion
            </Link>
          </li>
          <li className="footer-item">
            <Link
              to="/adverts"
              className="footer-links"
              onClick={() => handleLinkClick("/adverts")}
            >
              Adverts
            </Link>
          </li>
          <li className="footer-item">
            <Link
              to="/contact"
              className="footer-links"
              onClick={() => handleLinkClick("/contact")}
            >
              Contact
            </Link>
          </li>
        </ul>
        <div className="footer-logo">
          <Link
            to="/"
            className="footer-logo-link"
            onClick={() => handleLinkClick("/")}
          >
            <img src="/images/logos/logo-white.webp" alt="Logo" />
          </Link>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-copyright">
          Copyright &copy; 2024 - Augusts Autumn
        </div>
      </div>
    </footer>
  );
}

export default Footer;
